import createMenu from './ui/menu/menu';
import createImages from './ui/images/images';
import createArrows from './ui/arrows/arrows';
import createBuyButton from './ui/button/button';
import createCopyright from './ui/copyright/copyright';
import createInfo from './ui/info/info';
import createAnchor from './ui/anchor/anchor';

import {clearHash} from './ui/utils';

window.onload = createUI;
window.onhashchange = createUI;

function createUI() {
    const hash = clearHash(location.hash);

    createMenu(hash);
    createCopyright(hash);

    if (hash !== '') {
        createAnchor(hash);
        createInfo(hash);
        createImages(hash);
        createArrows(hash);
        createBuyButton(hash);
    }
}
